<div
  class="solicitud-banner flex align-items-center gap-2 px-3 py-2 border-round"
  [class.solicitud-banner--eliminar]="esEliminar()"
>
  <i class="pi text-sm" [ngClass]="copy().icono" aria-hidden="true"></i>

  <span class="flex-1 min-w-0 text-sm">
    <span class="font-medium">{{ copy().etiqueta }}:</span>
    {{ solicitud().motivo || 'sin detalle.' }}
  </span>

  <p-button
    type="button"
    icon="pi pi-ellipsis-v"
    styleClass="p-button-text p-button-sm"
    [ariaLabel]="'Acciones de ' + copy().etiqueta"
    (onClick)="accionesMenu.toggle($event)"
  />
  <p-menu #accionesMenu [model]="menuItems()" [popup]="true" appendTo="body" />
</div>
